/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import * as fv from "focus-visible";
import * as fw from "focus-within-polyfill";

import "./src/assets/sass/reset.scss";
import "./src/assets/sass/general.scss";
import "shared/dist/fonts.css";
// Revert this change from DCX-4073, tackle later
import "shared/dist/style.css"; // handled conditionally below to allow for hot reloading in development
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import {
  SalesforceMessagingContextProvider,
  SalesforceMessagingConfig,
} from "shared";
import { SearchContextProvider } from "./src/apps/website/hooks/useSearchContext";

// Revert this change from DCX-4073, tackle later
// // allows hot reloading of Shared component styles in development
// if (process.env.NODE_ENV !== "development") {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
//   require("shared/dist/style.css");
// }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  const orgId = process.env.GATSBY_SALESFORCE_ORG_ID;
  const deploymentName = process.env.GATSBY_SALESFORCE_MESSAGING_DEPLOYMENT_NAME;
  const siteUrl = process.env.GATSBY_SALESFORCE_MESSAGING_SITE_URL;
  const scrt2URL = process.env.GATSBY_SALESFORCE_MESSAGING_SCRT2_URL;

  if (!orgId || !deploymentName || !siteUrl || !scrt2URL) {
    throw new Error("Missing Salesforce Messaging environment variables");
  }

  const config: SalesforceMessagingConfig = {
    orgId,
    deploymentName,
    siteUrl,
    scrt2URL,
  };

  return (
    <SalesforceMessagingContextProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <SearchContextProvider>
          {element}
        </SearchContextProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SalesforceMessagingContextProvider>
  );
};
